export default __webpack_public_path__ + "ec04af98eb13cabbb27537b52ef08b84.png";